


export const layouts = {
'iframe': () => import('/E:/code/web/mjb_admin/src/layout/iframe.vue'),
'index': () => import('/E:/code/web/mjb_admin/src/layout/index.vue'),
'components/AppSetting/index': () => import('/E:/code/web/mjb_admin/src/layout/components/AppSetting/index.vue'),
'components/BuyIt/index': () => import('/E:/code/web/mjb_admin/src/layout/components/BuyIt/index.vue'),
'components/Header/index': () => import('/E:/code/web/mjb_admin/src/layout/components/Header/index.vue'),
'components/Logo/index': () => import('/E:/code/web/mjb_admin/src/layout/components/Logo/index.vue'),
'components/MainSidebar/index': () => import('/E:/code/web/mjb_admin/src/layout/components/MainSidebar/index.vue'),
'components/Search/index': () => import('/E:/code/web/mjb_admin/src/layout/components/Search/index.vue'),
'components/SidebarItem/index': () => import('/E:/code/web/mjb_admin/src/layout/components/SidebarItem/index.vue'),
'components/SubSidebar/index': () => import('/E:/code/web/mjb_admin/src/layout/components/SubSidebar/index.vue'),
'components/Tools/index': () => import('/E:/code/web/mjb_admin/src/layout/components/Tools/index.vue'),
'components/Topbar/index': () => import('/E:/code/web/mjb_admin/src/layout/components/Topbar/index.vue'),
'components/Tools/Notification/index': () => import('/E:/code/web/mjb_admin/src/layout/components/Tools/Notification/index.vue'),
'components/Topbar/Tabbar/index': () => import('/E:/code/web/mjb_admin/src/layout/components/Topbar/Tabbar/index.vue'),
'components/Topbar/Toolbar/index': () => import('/E:/code/web/mjb_admin/src/layout/components/Topbar/Toolbar/index.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'index'],
      children: [ {...route, path: ''} ],
    }
  })
}
